import type { DesktopOSName } from '#dn-types/downloads.ts';
import type { LinuxInstallMethod } from '../package-install.ts';

export function buildEnrollCommand(os: DesktopOSName, token: string | undefined, installMethod?: LinuxInstallMethod) {
  const command =
    os === 'Windows' ? "& 'C:\\Program Files\\Defined Networking\\DNClient\\dnclient.exe'"
      // Package installs put dnclient on the PATH; binary installs run it from the download directory
    : installMethod && installMethod !== 'binary' ? 'sudo dnclient'
    : 'sudo ./dnclient';

  return `${command} enroll -code ${token ?? '<loading…>'}`;
}
